import { type CountryResponse, getCountries } from '@api/countries-api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface UseCountriesResult {
  countries: CountryResponse[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useCountries(): UseCountriesResult {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey: ['countries'],
    queryFn: getCountries,
    staleTime: 5 * 60_000,
  });

  const refetch = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: ['countries'] });
  }, [queryClient]);

  return {
    countries: data ?? [],
    isLoading,
    error: error ? (error instanceof Error ? error.message : 'Failed to load countries') : null,
    refetch,
  };
}
